var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.logineoCalendar)?_c('b-container',[_c('CalendarList')],1):_c('b-container',[_c('CalendarHeader'),_c('hr'),_c('CalendarNavigation'),_c('CalendarDisplay'),_c('CalendarCalendarsList')],1)}
var staticRenderFns = []

export { render, staticRenderFns }